import { render, staticRenderFns } from "./tab-item-head.vue?vue&type=template&id=116e847a&scoped=true&"
import script from "./tab-item-head.vue?vue&type=script&lang=js&"
export * from "./tab-item-head.vue?vue&type=script&lang=js&"
import style0 from "./tab-item-head.vue?vue&type=style&index=0&id=116e847a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116e847a",
  null
  
)

export default component.exports